import { render, staticRenderFns } from "./UpdatePwd.vue?vue&type=template&id=c0b87738&scoped=true&"
import script from "./UpdatePwd.vue?vue&type=script&lang=js&"
export * from "./UpdatePwd.vue?vue&type=script&lang=js&"
import style0 from "./UpdatePwd.vue?vue&type=style&index=0&id=c0b87738&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0b87738",
  null
  
)

export default component.exports